import Vue from 'vue';
import VueCookies from 'vue-cookies';
import Vuex from 'vuex';

import auth from '@/auth/auth.store';
import portal from '@/portal/portal.store';

Vue.use(VueCookies);
Vue.use(Vuex);

const stores = {
  auth,
  portal,
};
const store = new Vuex.Store(stores[GLOBALS.APP]);

export default store;
